import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { redirectToLogin } from "@/auth/actions";

// /auth/login on the SPA side is a thin redirect to the BFF's
// /auth/login (which begins the PKCE flow with Keycloak). React
// Router catches the in-app URL; this component triggers the
// hand-off to the server-side flow.
//
// The ref guard is critical: React StrictMode re-runs effects, and
// `useSearchParams` (used previously) returns a NEW URLSearchParams
// instance on every render. Both would cause `window.location.assign`
// to fire repeatedly, each call cancelling the previous in-flight
// navigation, so the browser never actually leaves for Keycloak -
// the URL would just cycle between /auth/login and /. We read the
// URL directly off `window.location.search` and fire exactly once.

export function LoginPage() {
  const ranRef = useRef(false);
  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    const next = new URLSearchParams(window.location.search).get("next");
    redirectToLogin(next ?? undefined);
  }, []);
  return (
    <section className="mx-auto max-w-screen-md px-4 py-16 text-center">
      <p className="text-sm text-ink/55">
        <FormattedMessage id="auth.redirecting" defaultMessage="Redirecting to login…" />
      </p>
    </section>
  );
}
